import React from "react";
import Colors from "../../Constants/Colors";
import Icons from "../../Constants/Icons";

const PlanList = ({ currentUsers = [], onEdit, onToggleStatus, onDelete }) => {
  return (
    <div className="premium-user-list-wrapper">
      <div className="premium-scroll-container">
        {currentUsers
          ?.sort((a, b) => a.order - b.order)
          ?.map((item, index) => (
            <div key={item._id || index} className="premium-table-row">
              {/* PLAN */}
              <div style={{ width: "22%" }} className="plan-cell">
                <img src={item.icon} className="plan-icon" />

                <div className="plan-info">
                  <div className="plan-title-row">
                    <span className="plan-title">{item.title}</span>

                    <span className={`plan-type ${item.type.toLowerCase()}`}>
                      {item.type}
                    </span>
                  </div>

                  <div className="plan-badges">
                    {item.highlightText && (
                      <span className="plan-badge">{item.highlightText}</span>
                    )}

                    {item.isRecommended && (
                      <span className="recommended-badge">🔥 Popular</span>
                    )}
                  </div>

                  <div className="plan-price">
                    {item.type === "PRO" && item.pricing?.price
                      ? `₹${item.pricing.price}/${item.pricing.interval?.toLowerCase()}`
                      : item.type === "AMBASSADOR"
                        ? `${item.pricing?.interval?.toLowerCase()} access`
                        : "Free"}
                  </div>
                </div>
              </div>

              {/* DESCRIPTION */}
              <div style={{ width: "28%" }} className="plan-desc">
                {item.description}
              </div>

              {/* ORDER */}
              <div style={{ width: "8%" }} className="plan-order">
                #{item.order}
              </div>

              {/* STATUS */}
              <div
                style={{ width: "10%" }}
                onClick={() => onToggleStatus(item)}
                className="user_Status category_w"
              >
                <button
                  className={`status-btn ${item.isActive ? "active" : "inactive"}`}
                >
                  {item.isActive ? "Active" : "Inactive"}
                </button>
              </div>

              {/* ACTION */}
              <div style={{ width: "7%", display: "flex", gap: "10px" }}>
                <img
                  src={Icons.edit}
                  onClick={() => onEdit(item)}
                  style={{ filter: "brightness(0) invert(1)" }}
                  className="action-icon pointer"
                />
                <img
                  src={Icons.delete}
                  style={{ filter: "brightness(0) invert(1)" }}
                  onClick={() => onDelete(item)}
                  className="action-icon pointer"
                />
              </div>
            </div>
          ))}
      </div>

      {/* STYLE */}
      <style>{`

        .premium-table-row {
          display: flex;
          padding: 18px 16px;
          border-bottom: 1px solid rgba(255,255,255,0.05);
          align-items: center;
          transition: 0.2s;
          justify-content: space-between;
        }

        .premium-table-row:hover {
          background: rgba(255,255,255,0.03);
        }

        .plan-cell {
          display: flex;
          align-items: flex-start;
          gap: 12px;
        }

        .plan-icon {
          width: 42px;
          height: 42px;
          border-radius: 10px;
        }

        .plan-info {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .plan-title-row {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .plan-title {
          color: #fff;
          font-weight: 600;
          font-size: 14px;
        }

        .plan-type {
          font-size: 10px;
          padding: 2px 6px;
          border-radius: 6px;
          font-weight: 500;
        }

        .plan-type.pro {
          background: #3b82f6;
          color: #fff;
        }

        .plan-type.free {
          background: #64748b;
          color: #fff;
        }

        .plan-type.ambassador {
          background: #a855f7;
          color: #fff;
        }

        .plan-badges {
          display: flex;
          gap: 5px;
          flex-wrap: wrap;
        }

        .plan-badge {
          background: #f59e0b;
          color: #000;
          padding: 2px 6px;
          border-radius: 6px;
          font-size: 10px;
        }

        .recommended-badge {
          background: #22c55e;
          color: #fff;
          padding: 2px 6px;
          border-radius: 6px;
          font-size: 10px;
        }

        .ambassador-badge {
          background: #a855f7;
          color: #fff;
          padding: 2px 6px;
          border-radius: 6px;
          font-size: 10px;
        }

        .plan-price {
          font-size: 12px;
          color: #22c55e;
          font-weight: 500;
        }

        .plan-desc {
          color: #cbd5f5;
          font-size: 13px;
          line-height: 1.4;
        }

        .plan-features {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
        }

        .feature-badge {
          background: rgba(255,255,255,0.08);
          padding: 4px 8px;
          border-radius: 8px;
          font-size: 11px;
          color: #fff;
        }

        .plan-order {
          color: #fff;
          font-weight: 500;
        }

        .status-btn {
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          border: none;
          cursor: pointer;
          font-weight: 500;
        }

        .status-btn.active {
          background: rgba(34,197,94,0.2);
          color: #22c55e;
        }

        .status-btn.inactive {
          background: rgba(239,68,68,0.2);
          color: #ef4444;
        }

        .action-icon {
          width: 18px;
          height: 18px;
          opacity: 0.8;
          transition: 0.2s;
        }

        .action-icon:hover {
          opacity: 1;
          transform: scale(1.1);
        }

      `}</style>
    </div>
  );
};

export default React.memo(PlanList);
